import a from '../assets/svg/skills/adobeaudition.svg'
import b from '../assets/svg/skills/adobeaudition.svg'
import c from '../assets/svg/skills/adobeaudition.svg'
import d from '../assets/svg/skills/adobeaudition.svg'
import e from '../assets/svg/skills/adobeaudition.svg'
import f from '../assets/svg/skills/adobeaudition.svg'
import g from '../assets/svg/skills/adobeaudition.svg'
import h from '../assets/svg/skills/adobeaudition.svg'
import i from '../assets/svg/skills/adobeaudition.svg'
import z from '../assets/svg/skills/adobeaudition.svg'
import w from '../assets/svg/skills/adobeaudition.svg'
import y from '../assets/svg/skills/adobeaudition.svg'
import k from '../assets/svg/skills/adobeaudition.svg'

export const skillsImage = (skill) => {
    const skillID = skill.toLowerCase();
    switch (skillID) {
        case 'مراجع بین المللی':
            return a;
        case 'فرمولاسیون':
            return b;
        case 'پروژه های صنعتی و دانشگاهی':
            return c;
        case 'شرکت پخش':
            return d;
        case 'بازاریابی':
            return e;
        case 'JJ':
            return f;
        case 'مسئول فنی':
            return g;
        case '-فرمولاسیون':
            return h;
        case 'GgMP':
            return i;
        case 'ترخیص':
            return z;
        case 'KK':
            return w;
        case 'مشاوره':
            return y;
        case 'رگلاتوری':
            return k;
        default:
            break;
    }
}
